import {
  DATOS_FIJOS_MEDICAMENTO,
  CODIGO_TIPO_SERVICIO_MEDICAMENTO,
} from "./MedicamentoConstant";

export const getNombreProcedimiento = (procedimiento) => {
  const { nombreCobertura, cobertura } = procedimiento;
  if (nombreCobertura === "Totales") {
    return <span>{nombreCobertura}</span>;
  }
  return nombreCobertura ? `(${cobertura}) ${nombreCobertura}` : cobertura;
};

export const getTipoServicioTipoCobertura = (tipoServicio) => {
  return Number(tipoServicio + DATOS_FIJOS_MEDICAMENTO.CODIGO_TIPO_COBERTURA);
};

export const getObjetoMedicamento = (numeroMedicamento) => {
  const fragmentosMedicamento = numeroMedicamento?.split("-");

  if (fragmentosMedicamento?.length === 4) {
    return {
      anio: fragmentosMedicamento[0],
      compania: fragmentosMedicamento[1],
      ramo: fragmentosMedicamento[2],
      secuencial: fragmentosMedicamento[3],
    };
  }

  return null;
};

export const parseStringMedicamento = (numeroMedicamento) => {
  if (typeof numeroMedicamento !== "string" || numeroMedicamento.length < 8) {
    return null;
  }

  return {
    ano: numeroMedicamento.substring(0, 4),
    compania: numeroMedicamento.substring(4, 6),
    ramo: numeroMedicamento.substring(6, 8),
    secuencial: numeroMedicamento.substring(8),
  };
};

export const desfragmentarCodigoMedicamento = (codigo) => {
  // Verificar si el código tiene el formato correcto, ejemplo P94-5017941 o H95-5017935
  const regex = /^[PH]\d+-\d+$/;
  if (!regex.test(codigo)) {
    return null;
  }

  // Extraer los valores necesarios del código
  const compania = codigo[0] === "P" ? 96 : 30;
  const ramo = parseInt(codigo.substring(1, codigo.indexOf("-")), 10);
  const secuencial = parseInt(codigo.substring(codigo.indexOf("-") + 1), 10);

  return {
    compania,
    ramo,
    secuencial,
  };
};

export const fragmentarCodigoMedicamento = (compania, ramo, secuencial) => {
  const primerCaracter = compania === 30 ? "H" : "P";

  const numeroMedicamento = `${primerCaracter}${ramo}-${secuencial}`;

  return numeroMedicamento;
};

export const getStandVirtualFullUrl = (token) => {
  return `${process.env.REACT_APP_STAND_VIRTUAL_URL}?tid=${token}&compania=${process.env.REACT_APP_COMPANY}`;
};

export const homologarCodigoTipoServicio = (codigoTipoServicio) => {
  if (
    codigoTipoServicio === CODIGO_TIPO_SERVICIO_MEDICAMENTO.DIALISIS ||
    codigoTipoServicio === CODIGO_TIPO_SERVICIO_MEDICAMENTO.QUIMIOTERAPIA ||
    codigoTipoServicio === CODIGO_TIPO_SERVICIO_MEDICAMENTO.RADIOTERAPIA
  ) {
    return CODIGO_TIPO_SERVICIO_MEDICAMENTO.ALTO_COSTO;
  }

  return codigoTipoServicio;
};

export const agruparObjetoMedicamento = (medList) => {
  if (!medList || medList.length === 0) return null;
  if (medList.length === 1) return medList[0];

  return medList.reduce(
    (acumulado, medicamento, index) => {
      if (index === 0) return medicamento;

      acumulado.montoPagado += Number(medicamento.montoPagado);
      acumulado.montoReclamado += Number(medicamento.montoReclamado);
      acumulado.nombreCobertura += `, ${medicamento.nombreCobertura}`;
      acumulado.cobertura += `, ${medicamento.cobertura}`;

      return acumulado;
    },
    { ...medList[0] }
  );
};

export const getMontoTotalReclamado = (procedimientos) => {
  return procedimientos?.reduce(
    (acumulador, procedimiento) => acumulador + procedimiento.montoReclamado,
    0
  );
};

export const getMontoAutorizadoPrimera = (procedimientos) => {
  return procedimientos?.reduce(
    (acumulador, procedimiento) =>
      acumulador + procedimiento.montoAutorizacionPrimera,
    0
  );
};

export const getMontoAutorizadoHumano = (procedimientos) => {
  return procedimientos?.reduce(
    (acumulador, procedimiento) =>
      acumulador + procedimiento.montoAutorizacionHumano,
    0
  );
};

export const getMontoAutorizadoTotal = (procedimientos) => {
  return procedimientos?.reduce(
    (acumulador, procedimiento) => acumulador + procedimiento.montoAutorizado,
    0
  );
};

export const normalizarMontoDiferencia = (procedimientos) => {
  return procedimientos?.map((procedimiento) => ({
    ...procedimiento,
    montoDiferencia:
      procedimiento.montoAfiliado !== undefined &&
      procedimiento.montoAfiliado !== null
        ? procedimiento.montoAfiliado
        : procedimiento.montoAsegurado,
  }));
};

export const getMontoDiferencia = (procedimientos) => {
  const procedimientosNormalizados = normalizarMontoDiferencia(procedimientos);
  return procedimientosNormalizados?.reduce(
    (acumulador, procedimiento) =>
      acumulador + (procedimiento.montoDiferencia || 0),
    0
  );
};

const convertirImagenABase64 = async (urlImagen) => {
  if (typeof urlImagen === "string" && urlImagen.startsWith("data:")) {
    return urlImagen;
  }

  try {
    const response = await fetch(urlImagen);
    const blob = await response.blob();
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        resolve(reader.result);
      };
      reader.onerror = () => {
        resolve("");
      };
      reader.readAsDataURL(blob);
    });
  } catch (error) {
    return new Promise((resolve) => {
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
        try {
          const dataURL = canvas.toDataURL("image/png");
          resolve(dataURL);
        } catch (err) {
          resolve("");
        }
      };
      img.onerror = () => {
        resolve("");
      };
      img.src = urlImagen;
    });
  }
};

export const generarVoucherHTML = async (
  afiliadoData,
  notificarReclamacionData,
  tablaMedicamentosData,
  empresa,
  Colors,
  moment,
  formatearMontoPesos,
  nombrePrestador,
  codigoPrestador
) => {
  const reclamacion = notificarReclamacionData?.data?.reclamacion || "N/A";

  const {
    nombres = "",
    apellidos = "",
    cedula = "",
    carnet = "",
    nss = "",
    fecha_nacimiento = "",
    plan = "",
    cod_poliza = "",
  } = afiliadoData || {};

  const anioActual = moment().year();
  const compania = cod_poliza && cod_poliza.length >= 2 
    ? cod_poliza.substring(0, 2) 
    : "30";
  const ramo = cod_poliza && cod_poliza.length >= 4 
    ? cod_poliza.substring(2, 4) 
    : "95";

  const numeroReclamacion = `${anioActual}-${compania}-${ramo}-${reclamacion}`;

  const medicamentos = tablaMedicamentosData.filter(
    (item) => item.key !== 0 && item.key !== "0"
  );

  const montoTotalReclamado = medicamentos.reduce((total, item) => {
    return total + parseFloat(item.montoReclamado || 0);
  }, 0);

  const montoTotalAutorizado = medicamentos.reduce((total, item) => {
    return total + parseFloat(item.montoAutorizado || 0);
  }, 0);

  const montoTotalDiferencia = medicamentos.reduce((total, item) => {
    return total + parseFloat(item.montoDiferencia || 0);
  }, 0);

  const fechaActual = moment().format("DD/MM/YYYY");
  const fechaHoraActual = moment().format("DD/MM/YYYY HH:mm:ss");
  const fechaNacimientoFormateada = fecha_nacimiento 
    ? moment(fecha_nacimiento).format("DD/MM/YYYY") 
    : "N/A";

  const colorPrincipal = empresa?.COLOR_PRINCIPAL || Colors.primaryHumano;
  const colorFondo = Colors.backgroundColor;
  const colorTexto = Colors.txt;
  const colorTextoDetalle = Colors.txtDetail;
  const colorBorde = Colors.lineColor;
  
  let logoEmpresaBase64 = "";
  if (empresa?.LOGO_AZUL) {
    try {
      if (typeof empresa.LOGO_AZUL === "string") {
        if (empresa.LOGO_AZUL.startsWith("data:")) {
          logoEmpresaBase64 = empresa.LOGO_AZUL;
        } else if (empresa.LOGO_AZUL.startsWith("http")) {
          logoEmpresaBase64 = await convertirImagenABase64(empresa.LOGO_AZUL);
        } else {
          const logoPath = empresa?.CODIGO === "30" 
            ? `${window.location.origin}/images/logo-humano-seguro-azul.jpg`
            : `${window.location.origin}/images/logo-primera-azul.png`;
          logoEmpresaBase64 = await convertirImagenABase64(logoPath);
        }
      } else {
        const logoUrl = empresa.LOGO_AZUL;
        logoEmpresaBase64 = await convertirImagenABase64(logoUrl);
      }
    } catch (error) {
      logoEmpresaBase64 = "";
    }
  }

  const htmlContent = `
<!DOCTYPE html>
<html lang="es">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Voucher de Reclamación - ${numeroReclamacion}</title>
    <style>
        * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
        }
        body {
            font-family: Arial, sans-serif;
            padding: 20px;
            background-color: ${colorFondo};
        }
        .voucher-container {
            max-width: 800px;
            margin: 0 auto;
            background-color: ${Colors.white};
            padding: 30px;
            box-shadow: 0 0 10px rgba(0,0,0,0.1);
        }
        .header {
            text-align: center;
            border-bottom: 3px solid ${colorPrincipal};
            padding-bottom: 20px;
            margin-bottom: 30px;
        }
        .header h1 {
            color: ${colorPrincipal};
            font-size: 28px;
            margin-bottom: 10px;
        }
        .header h2 {
            color: ${colorTextoDetalle};
            font-size: 20px;
            font-weight: normal;
        }
        .section {
            margin-bottom: 25px;
        }
        .section-title {
            background-color: ${colorPrincipal};
            color: ${Colors.white};
            padding: 10px 15px;
            font-size: 18px;
            font-weight: bold;
            margin-bottom: 15px;
        }
        .info-row {
            display: flex;
            padding: 8px 0;
            border-bottom: 1px solid ${colorBorde};
        }
        .info-label {
            font-weight: bold;
            width: 200px;
            color: ${colorTextoDetalle};
        }
        .info-value {
            flex: 1;
            color: ${colorTexto};
        }
        table {
            width: 100%;
            border-collapse: collapse;
            margin-top: 15px;
        }
        th {
            background-color: ${colorPrincipal};
            color: ${Colors.white};
            padding: 12px;
            text-align: left;
            font-size: 14px;
        }
        td {
            padding: 10px 12px;
            border-bottom: 1px solid ${colorBorde};
            font-size: 13px;
            color: ${colorTexto};
        }
        tr:hover {
            background-color: ${Colors.greyLight};
        }
        .totals-row {
            background-color: ${Colors.greyLight};
            font-weight: bold;
        }
        .text-right {
            text-align: right;
        }
        .footer {
            margin-top: 30px;
            padding-top: 20px;
            border-top: 2px solid ${colorPrincipal};
            text-align: center;
            color: ${colorTextoDetalle};
            font-size: 12px;
        }
        @media print {
            body {
                background-color: white;
                padding: 0;
            }
            .voucher-container {
                box-shadow: none;
                padding: 20px;
            }
        }
    </style>
</head>
<body>
    <div class="voucher-container">
        <div class="header">
            ${logoEmpresaBase64 ? `<div style="text-align: center; margin-bottom: 20px;">
                <img src="${logoEmpresaBase64}" alt="Logo" style="max-width: 200px; height: auto;" />
            </div>` : ""}
            <h1>VOUCHER DE RECLAMACIÓN</h1>
            <h2>Número de Reclamación: ${numeroReclamacion}</h2>
            <p style="margin-top: 10px; color: ${colorTextoDetalle};">Fecha de Emisión: ${fechaHoraActual}</p>
        </div>

        <div class="section">
            <div class="section-title">DATOS DEL PRESTADOR</div>
            <div class="info-row">
                <div class="info-label">Código:</div>
                <div class="info-value">${codigoPrestador || "N/A"}</div>
            </div>
            <div class="info-row">
                <div class="info-label">PSS:</div>
                <div class="info-value">${nombrePrestador || "N/A"}</div>
            </div>
        </div>

        <div class="section">
            <div class="section-title">DATOS DEL AFILIADO</div>
            <div class="info-row">
                <div class="info-label">Nombre Completo:</div>
                <div class="info-value">${nombres} ${apellidos}</div>
            </div>
            <div class="info-row">
                <div class="info-label">Cédula:</div>
                <div class="info-value">${cedula || "N/A"}</div>
            </div>
            <div class="info-row">
                <div class="info-label">Carnet:</div>
                <div class="info-value">${carnet || "N/A"}</div>
            </div>
            <div class="info-row">
                <div class="info-label">NSS:</div>
                <div class="info-value">${nss || "N/A"}</div>
            </div>
            <div class="info-row">
                <div class="info-label">Fecha de Nacimiento:</div>
                <div class="info-value">${fechaNacimientoFormateada}</div>
            </div>
            <div class="info-row">
                <div class="info-label">Plan:</div>
                <div class="info-value">${plan || "N/A"}</div>
            </div>
            <div class="info-row">
                <div class="info-label">Póliza:</div>
                <div class="info-value">${cod_poliza || "N/A"}</div>
            </div>
        </div>

        <div class="section">
            <div class="section-title">COBERTURAS (MEDICAMENTOS)</div>
            <table>
                <thead>
                    <tr>
                        <th>Código</th>
                        <th>Descripción</th>
                        <th>Cantidad</th>
                        <th class="text-right">Monto Reclamado</th>
                        <th class="text-right">Monto Autorizado</th>
                        <th class="text-right">Diferencia</th>
                    </tr>
                </thead>
                <tbody>
                    ${medicamentos.map((medicamento) => `
                        <tr>
                            <td>${medicamento.codigo || "N/A"}</td>
                            <td>${medicamento.descripcion || "N/A"}</td>
                            <td>${medicamento.cantidad || "0"}</td>
                            <td class="text-right">${formatearMontoPesos(String(medicamento.montoReclamado || 0))}</td>
                            <td class="text-right">${formatearMontoPesos(String(medicamento.montoAutorizado || 0))}</td>
                            <td class="text-right">${formatearMontoPesos(String(medicamento.montoDiferencia || 0))}</td>
                        </tr>
                    `).join("")}
                    <tr class="totals-row">
                        <td colspan="3"><strong>TOTALES</strong></td>
                        <td class="text-right"><strong>${formatearMontoPesos(String(montoTotalReclamado))}</strong></td>
                        <td class="text-right"><strong>${formatearMontoPesos(String(montoTotalAutorizado))}</strong></td>
                        <td class="text-right"><strong>${formatearMontoPesos(String(montoTotalDiferencia))}</strong></td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="footer">
            <p>Este documento fue generado el ${fechaHoraActual} desde WebSalud</p>
            <p>Número de Reclamación: ${numeroReclamacion}</p>
        </div>
    </div>
</body>
</html>
  `;

  const blob = new Blob([htmlContent], { type: "text/html;charset=utf-8" });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `Voucher_Reclamacion_${numeroReclamacion}_${fechaActual.replace(/\//g, "_")}.html`;
  document.body.appendChild(a);
  a.click();
  window.URL.revokeObjectURL(url);
  document.body.removeChild(a);
};
